import React from "react";
import PropTypes from "prop-types";

import { Header, Image, DarkText, LightText } from "./Section.styles";

const WorkItemFormVehicleSection = ({ vehicle }) => {
  return (
    <Header>
      <Image src="/assets/images/car_icon.svg" />
      <DarkText>{vehicle.make}</DarkText>
      <DarkText>{vehicle.model}</DarkText>
      <LightText>{vehicle.year}</LightText>
    </Header>
  );
};

WorkItemFormVehicleSection.propTypes = {
  vehicle: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string
  }).isRequired
};

export default WorkItemFormVehicleSection;
